// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"588":"1fd46f49","923":"935d5806"}[chunkId] + ".chunk.js";
};